import { render, staticRenderFns } from "./RealGreenFrame.vue?vue&type=template&id=f4b89d70"
import script from "./RealGreenFrame.vue?vue&type=script&lang=js"
export * from "./RealGreenFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports